import { baseConf } from '@config/base'

export type Config = typeof conf

export const conf = {
  ...baseConf,
  thirdPartyConfig: {
    googleTagManager: {
      id: 'GTM-TNL2F7CJ',
      layer: 'dataLayer',
    },
    fullStory: {
      host: 'fullstory.com',
      script: 'edge.fullstory.com/s/fs.js',
      orgId: '', // TODO: Update to SH FullStory org ID
    },
    transcend: {
      id: '1c1f8e90-47d0-4bba-a1a2-472d59b002a2',
    },
  },
  api: {
    auth: 'https://auth.grammarly.com/auth/v3',
    signin: 'https://superhuman.com/auth/signin',
    signup: 'https://superhuman.com/auth/signup',
  },
  domains: {
    cookie: '.superhuman.com',
    controlPlaneCookie: '.superhuman.com', // won't be required, just for consistency
    main: 'superhuman.com',
    grammarly: 'grammarly.com',
    coda: 'coda.io',
  },
  sessionTransfer: {
    toCoda: 'https://coda.io/v1/mediator/initiate',
    toGrammarly: 'https://auth.grammarly.com/v1/mediator/initiate',
  },
  tracking: {
    ...baseConf.tracking,
    gnar: {
      url: 'https://gnar.grammarly.com',
    },
    shLegacyTracking: {
      apiUrl: 'https://mail.superhuman.com/~backend/v3/metrics.write',
      enabled: true,
    },
  },
  paths: {
    ...baseConf.paths,
    basePath: 'https://superhuman.com',
    agentStore: 'https://superhuman.com/store/agents',
    mail: {
      ...baseConf.paths.mail,
      basePath: 'https://mail.superhuman.com',
      landing: 'https://superhuman.com/products/mail',
    },
    nomos: {
      ...baseConf.paths.nomos,
      basePath: 'https://settings.superhuman.com',
    },
  },
}
